<template>
    <div class="edit-popup" ref="el">
        <a v-if="!loading" class="emn__edit-trigger inverted" @click="editing = !editing">
            <i class="icon icon--" :class="[`icon--${icon}`, { 'icon--action-edit--restart': restart }]"></i>
        </a>
        <i class="edit-popup__loader icon icon--common-spinner spinner" :class="{ 'spinner--finished': !loading }"></i>

        <transition name="fade">
            <span
                v-if="editing"
                class="lazy-parameter__editing"
                :class="{ 'lazy-parameter__editing--top': editing, 'lazy-parameter__editing--fixed': overlayFixed }"
                v-click-outside="discard"
                :style="popupStyles"
            >
                <span class="lazy-parameter__editing__container" :class="{ 'lazy-parameter__editing__container--padding-less': !containerPadded }">
                    <slot />
                </span>

                <span v-if="!disableEditButtons" class="lazy-parameter__editing__buttons">
                    <a @click="discard" class="lazy-parameter__editing__button">
                        <i class="icon icon--action-decline"></i>
                        {{ $t('buttons.cancel') }}
                    </a>
                    <a @click="save()" class="lazy-parameter__editing__button">
                        <i class="icon icon--action-approve"></i>
                        {{ $t('buttons.save') }}
                    </a>
                </span>
            </span>
        </transition>
    </div>
</template>

<script>
import clickOutside from '@/directives/click-outside';

export default {
    directives: {
        clickOutside,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        restart: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
            default: 'action-edit',
        },
        disableEditButtons: {
            type: Boolean,
            default: false,
        },
        containerPadded: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            editing: false,
            overlayFixed: false,
            popupPosition: {
                top: 0,
                left: 0,
            },
            tableWrapper: null,
        };
    },
    computed: {
        popupStyles() {
            if (!this.overlayFixed) return null;
            return {
                top: this.popupPosition.top + 'px',
                left: this.popupPosition.left + 'px',
            };
        },
    },
    watch: {
        editing(newVal) {
            if (newVal) {
                this.positionOverlayFixed();
                this.$emit('edit');
            }
        },
    },
    mounted() {
        this.positionOverlayFixed();
        this.addListeners();
    },
    destroyed() {
        this.removeListeners();
    },
    methods: {
        addListeners() {
            window.addEventListener('resize', this.positionOverlayFixed);
            window.addEventListener('scroll', this.positionOverlayFixed);
        },
        removeListeners() {
            window.removeEventListener('resize', this.positionOverlayFixed);
            window.removeEventListener('scroll', this.positionOverlayFixed);
            if (this.tableWrapper) {
                this.tableWrapper.removeEventListener('scroll', this.positionOverlayFixed);
            }
        },
        discard() {
            this.editing = false;
            this.$emit('discard');
        },
        save() {
            this.editing = false;
            this.$emit('save');
        },
        positionOverlayFixed() {
            const el = this.$refs.el;
            if (el) {
                const popupRect = el.getBoundingClientRect();
                this.popupPosition.top = popupRect.top;
                this.popupPosition.left = popupRect.left;

                this.overlayFixed = true;
                this.setTableWrapperListener(el);
            }
        },
        setTableWrapperListener(el) {
            if (!this.tableWrapper && el.closest('.table-wrapper')) {
                this.tableWrapper = el.closest('.table-wrapper');
                this.tableWrapper.addEventListener('scroll', this.positionOverlayFixed);
            }
        },
    },
};
</script>

<style lang="scss">
.edit-popup {
    position: relative;
    display: inline-block;

    &__row {
        &:not(:last-child) {
            margin-bottom: 12px;
        }
    }
}
</style>
